export const NO_DEPOSIT_BONUS_PATHNAME = '/noDepositBonus/'
export const REFER_A_FRIEND_PATHNAME = '/referFriends'
export const DYNAMIC_DEPOSIT_BONUS_PATHNAME = '/depositBonus/'
export const DEPOSIT_BONUS_PATHNAME = '/depositBonus'
export const TRADING_BONUS_PATHNAME = '/tradingBonus'
export const REDEPOSIT_PATHNAME = '/redepositBonus'
export const WELCOME_BONUS_PATHNAME = '/welcomeBonus'
export const LOSS_RECOVER_PATHNAME = '/lossRecover'
export const OFFLINE_REWARDS_PATHNAME = '/promotion/offlineRewards/'
export const FUNDS_GROWTH_PROMO_PATHNAME = '/fundsGrowthPromotion'
export const VPS_REFUND = '/vpsRefund'
export const TRADING_REWARDS_PATHNAME = '/tradingRewards/'
export const LUCKY_DRAW_PATHNAME = '/luckyDraw/'
export const TRADING_CONTEST_PATHNAME = '/tradingContest/'
